import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './right-inner.styl'

export default class Inner extends Component {
  static propTypes = {
    children: PropTypes.any,
    white: PropTypes.bool,
  }

  static defaultProps = {
    white: false
  }

  render() {
    const { white } = this.props
    const classNames = [styles.wrap]

    white && classNames.push(styles.white)

    return (
      <div className={classNames.join(' ')}>
        {this.props.children}
      </div>
    )
  }
}
